import AnalyticsDashboard from 'components/AnalyticsDashboard';

const REPORT_PATH = 'embed/looks/385?theme=Hidden_Components';
const OutstandingTotalLoanBalance = () => (
  <AnalyticsDashboard
    reportPath={REPORT_PATH}
    headerText="Outstanding total loan balance"
    showDateSelector={false}
    showDivider={false}
  />
);

export default OutstandingTotalLoanBalance;
